import { remark } from 'remark';
import remarkHtml from 'remark-html';

// Utils
import cn from '@/utils/cn';

// Types
import { ParagraphType } from './ParagraphType';

interface ParagraphProps {
  text: ParagraphType['text'];
  color: ParagraphType['color'];
  size: ParagraphType['size'];
  className?: string;
}

function Paragraph({ text, color, size, className = '' }: ParagraphProps) {
  const paragraphMarkDown = remark().use(remarkHtml).processSync(text).toString();

  return (
    <div
      className={cn([`text-${color}`, size, className])}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: paragraphMarkDown }}
    />
  );
}

export default Paragraph;
